import { useEffect, useState } from "react";
import {
  listPartnerListingCorrections,
  createPartnerListingCorrection,
} from "../../api/partnerPortalApi";

const PartnerListingCorrectionsPage = () => {
  const [corrections, setCorrections] = useState([]);
  const [form, setForm] = useState({
    clientViewId: "",
    canonicalListingId: "",
    correctionType: "wrong_price",
    proposedValue: "",
    notes: "",
  });
  const [message, setMessage] = useState("");

  const load = () =>
    listPartnerListingCorrections().then((body) => setCorrections(body.corrections || []));

  useEffect(() => {
    load();
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    await createPartnerListingCorrection(form);
    setMessage("Correction submitted for review.");
    await load();
  };

  return (
    <div className="cv-studio-section">
      <section className="panel-card">
        <h2>Submit correction</h2>
        <form onSubmit={submit}>
          <label className="admin-users-field">
            <span>Client View ID</span>
            <input
              value={form.clientViewId}
              onChange={(e) => setForm({ ...form, clientViewId: e.target.value })}
              required
            />
          </label>
          <label className="admin-users-field">
            <span>Listing ID</span>
            <input
              value={form.canonicalListingId}
              onChange={(e) => setForm({ ...form, canonicalListingId: e.target.value })}
              required
            />
          </label>
          <label className="admin-users-field">
            <span>Type</span>
            <select
              value={form.correctionType}
              onChange={(e) => setForm({ ...form, correctionType: e.target.value })}
            >
              <option value="wrong_price">Wrong price</option>
              <option value="stale_listing">Stale listing</option>
              <option value="wrong_address">Wrong address</option>
              <option value="other">Other</option>
            </select>
          </label>
          <label className="admin-users-field">
            <span>Proposed value</span>
            <input
              value={form.proposedValue}
              onChange={(e) => setForm({ ...form, proposedValue: e.target.value })}
            />
          </label>
          <label className="admin-users-field">
            <span>Notes</span>
            <textarea
              value={form.notes}
              onChange={(e) => setForm({ ...form, notes: e.target.value })}
              rows={3}
            />
          </label>
          <button type="submit" className="midpoint-share-button">
            Submit
          </button>
        </form>
        {message ? <p>{message}</p> : null}
      </section>
      <section className="panel-card">
        <h2>Your requests</h2>
        <ul className="cv-studio-simple-list">
          {corrections.map((c) => (
            <li key={c.id}>
              {c.correction_type} — {c.status} ({c.canonical_listing_id})
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default PartnerListingCorrectionsPage;
